const globalConfig = require('../config/config');

class ManageMyBookingButton {
    constructor() {
        this.buttonTemplate = Odigeo._.template(globalConfig.buttonTemplate, Odigeo.Utils.getTmplSettings());
        this.linkTemplate = Odigeo._.template(globalConfig.linkTemplate, Odigeo.Utils.getTmplSettings());
    }

    renderAsButton() {
        return this.buttonTemplate(this.getData());
    }

    renderAsLink() {
        return this.linkTemplate(this.getData());
    }

    getData() {
        return {
            keys: {
                mmbTxt: Odigeo.UIElements.translations.mmbTxt.myTripManageMyBookingButtonText,
            },
        };
    }
}
module.exports = new ManageMyBookingButton();

